var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.50002 4H28.5C28.8536 4 29.1928 4.14048 29.4428 4.39052C29.6929 4.64057 29.8334 4.97971 29.8334 5.33333V26.6667C29.8334 27.0203 29.6929 27.3594 29.4428 27.6095C29.1928 27.8595 28.8536 28 28.5 28H4.50002C4.1464 28 3.80726 27.8595 3.55721 27.6095C3.30716 27.3594 3.16669 27.0203 3.16669 26.6667V5.33333C3.16669 4.97971 3.30716 4.64057 3.55721 4.39052C3.80726 4.14048 4.1464 4 4.50002 4ZM27.1667 9.65067L16.596 19.1173L5.83335 9.62133V25.3333H27.1667V9.65067ZM6.51469 6.66667L16.5814 15.5493L26.5027 6.66667H6.51469Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.665fe25ae079b2b924992ddc29ee22ff.svg";
export { ForwardRef as ReactComponent };